import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  PaginatedcomponentResultsSideloadList,
  PatchedTurbineComponent,
  Turbine,
  TurbineComponentRetrieve,
} from "../../app/generated-axios-client";

export type ComponentPatchPayload = {
  id?: string;
  data: PatchedTurbineComponent;
};

export type SideloadedComponentInfo = {
  turbine: Record<string, Turbine>;
};

export interface ComponentState {
  component: TurbineComponentRetrieve | null;
  list: PaginatedcomponentResultsSideloadList;
  sideload: SideloadedComponentInfo | null;
}

const initialState: ComponentState = {
  component: null,
  list: {
    "pagination": {
      "total_items": 0,
      "total_pages": 0,
      "current_page": 0,
      "per_page": 0,
    },
    "results": {
      "component": [],
      "turbine": [],
    },
  },
  sideload: null,
};

export const componentSlice = createSlice({
  name: "component",
  initialState,
  reducers: {
    componentEdit: (_state, _action: PayloadAction<ComponentPatchPayload>) => {},
    addComponentSideload: (state, action: PayloadAction<SideloadedComponentInfo>) => {
      state.sideload = action.payload;
    },
    addComponentList: (
      state,
      action: PayloadAction<PaginatedcomponentResultsSideloadList>
    ) => {
      state.list = action.payload;
    },
    clearComponents: (_state, _action) => {
      return initialState;
    },
  },
});

export const componentActions = componentSlice.actions;
export default componentSlice.reducer;
